<script>
    export let src;
    export let alt;
</script>
<div style="position:relative;">
    <img src="{src}" alt="{alt}" class="vec-cursor-pointer img-fluid vec-shadow-sm vec-rounded-t-xl vec-rounded-br-xl vec-border vec-border-midGrey"/>
</div>
